import React from "react";
import { useTranslation } from "react-i18next";
import { INPUT, OUTPUT, CROP_ADVISORY, FINANCIAL } from "../data/navbar/menu";
import {
  SERVICES_PANEL_LABEL,
  SERVICES_PANEL_HEADING,
  SERVICES_INTRO_PARAGRAPH,
  SERVICES_CARD_BTN,
  INPUT_BADGE,
  INPUT_CARD_DESC,
  OUTPUT_BADGE,
  OUTPUT_CARD_DESC,
  ADVISORY_CARD_DESC,
  FINANCIAL_CARD_DESC,
} from "../data/i18n/services";
import inputPhoto from "../assets/images/service-input.jpeg";
import outputPhoto from "../assets/images/service-output.jpg";
import advisoryPhoto from "../assets/images/service-advisory.jpg";
import financialPhoto from "../assets/images/service-financial.jpg";
import "../styles/Services.css";

const cards = [
  {
    key: "input",
    letter: "I",
    photo: inputPhoto,
    badge: INPUT_BADGE,
    title: INPUT,
    desc: INPUT_CARD_DESC,
  },
  {
    key: "output",
    letter: "O",
    photo: outputPhoto,
    badge: OUTPUT_BADGE,
    title: OUTPUT,
    desc: OUTPUT_CARD_DESC,
  },
  {
    key: "advisory",
    letter: "A",
    photo: advisoryPhoto,
    badge: null,
    title: CROP_ADVISORY,
    desc: ADVISORY_CARD_DESC,
  },
  {
    key: "financial",
    letter: "F",
    photo: financialPhoto,
    badge: null,
    title: FINANCIAL,
    desc: FINANCIAL_CARD_DESC,
  },
];

const Services = () => {
  const { t } = useTranslation();
  return (
    <section className="services-band" id="services">
      <div className="services-top-row">
        <div className="services-green-panel">
          <div className="services-panel-label">{t(SERVICES_PANEL_LABEL)}</div>
          <h2 className="services-panel-heading">{t(SERVICES_PANEL_HEADING)}</h2>
        </div>
        <div className="services-right-copy">
          <p>{t(SERVICES_INTRO_PARAGRAPH)}</p>
        </div>
      </div>

      <div className="services-grid">
        {cards.map((card) => (
          <div className={`service-card service-card-${card.key}`} key={card.key}>
            <div className="service-card-photo">
              <span className="service-card-letter" aria-hidden="true">
                {card.letter}
              </span>
              <img src={card.photo} alt="" />
            </div>
            <div className="service-card-body">
              {card.badge && (
                <div className="service-card-badge">{t(card.badge)}</div>
              )}
              <h3 className="service-card-title">{t(card.title)}</h3>
              <p className="service-card-desc">{t(card.desc)}</p>
              <a className="service-card-btn" href="/#contact">
                {t(SERVICES_CARD_BTN)} →
              </a>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default Services;
